import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule, ChipModule } from '@progress/kendo-angular-buttons';
import { DateRangeSelectionModule } from '../../forecastui/date-range-selection/date-range-selection.module';
import { ForecastRxTreelistModule } from '../../forecastui/forecast-rxtreelist/forecast-rxtreelist.module';
import { GeneralWarningModalModule } from '../../forecastui/general-warning-modal/general-warning-modal.module';
import { ProductAdsHistoryLogComponent } from './product-ads-history-log.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModalModule,
    TooltipsModule,
    DropDownsModule,
    DialogsModule,
    GridModule,
    ButtonsModule,
    ChipModule,
    NgbTooltipModule,
    DateRangeSelectionModule,
    ForecastRxTreelistModule,
    GeneralWarningModalModule,
  ],
  declarations: [
    ProductAdsHistoryLogComponent
  ],
  exports: [
    ProductAdsHistoryLogComponent
  ]
})
export class ProductAdsHistoryLogModule { }
